import React from 'react';
import { cn } from '../ui-x';

/**
 * Navy by default — the reference reserves navy for "open a heavier surface"
 * and allows exactly one orange commit button per screen, which call sites opt
 * into with className="bg-brand-orange hover:bg-brand-orange-600".
 *
 * cn() is used so a className passed by a call site actually wins; the old
 * template string put the base colour last, which silently beat it.
 */
const Button = ({ children, className, onClick, type, disabled }) => {
  const onClickHandler = (e) => {
    if (typeof onClick === 'function') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <button
      className={cn(
        'inline-flex h-9 items-center justify-center whitespace-nowrap rounded-lg border border-transparent px-4 text-sm font-semibold text-white transition-colors',
        'bg-brand-navy hover:bg-brand-navy-800',
        'disabled:pointer-events-none disabled:opacity-50',
        className
      )}
      onClick={onClickHandler}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
